import Icon from '@ant-design/icons';
import React from 'react';
import { ReactComponent as IconSvg } from '../../assets/CloseX.svg';

export const CloseX = (props: React.ComponentProps<typeof Icon>) => {
  return <Icon component={IconSvg} {...props} />;
};
